import { render, staticRenderFns } from "./ThgRegistrationAtImageUpload.vue?vue&type=template&id=32968888"
import script from "./ThgRegistrationAtImageUpload.vue?vue&type=script&lang=ts"
export * from "./ThgRegistrationAtImageUpload.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports